export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-disconnected.daa3c87be39f0346756d056a481a0d4e.png";